import { useSubscription } from '@apollo/client';
import { gql } from 'graphql-tag';

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 3;

export const RESOURCE_REQUEST_MATCHING_SUBSCRIPTION = gql`
  subscription ResourceRequestMatchingCompleted(
    $page: Int!
    $pageSize: Int!
    $filter: ResourceRequestMatchingCompletedFilter
  ) {
    resourceRequestMatchingCompleted(
      page: $page
      pageSize: $pageSize
      filter: $filter
    ) {
      id
      resourceMatches {
        id
        userUri
        score
        displayText
      }
      resourceMatchesStatus
    }
  }
`;

const useResourceRequestMatchingSubscription = ({
  page,
  pageSize,
  resourceRequestUris,
  skipSubscription
}) => {
  const { data: { resourceRequestMatchingCompleted } = {} } = useSubscription(
    RESOURCE_REQUEST_MATCHING_SUBSCRIPTION,
    {
      variables: {
        page: page || DEFAULT_PAGE,
        pageSize: pageSize || DEFAULT_PAGE_SIZE,
        filter: {
          resourceRequestUris
        }
      },
      skip: skipSubscription
    }
  );

  return (
    resourceRequestMatchingCompleted || {
      id: null,
      resourceMatches: null,
      resourceMatchesStatus: null
    }
  );
};

export default useResourceRequestMatchingSubscription;
